import {
    combineReducers,
    logAction,
    useRelodeReducer,
    useSnackMiddleware,
} from "@relode/core";
import * as React from "react";

import { publicCandidateReducer } from "./candidate";
import {
    ClientPublicCandidateState,
    initialClientPublicCandidateState,
} from "./clientPublicCandidateState";
import {
    CombinedClientPublicCandidateActions,
    useCombinedClientPublicCandidateActions,
} from "./combinedClientPublicCandidateActions";
import {
    useCombinedClientPublicCandidateHandlers,
} from "./combinedClientPublicCandidateHandlers";
import { publicCandidateUIReducer } from "./ui";

const combinedReducers = combineReducers(
    publicCandidateUIReducer,
    publicCandidateReducer
);

type IClientPublicCandidateContext = {
    state: ClientPublicCandidateState;
    actions: CombinedClientPublicCandidateActions;
};

export const ClientPublicCandidateContext =
    React.createContext<IClientPublicCandidateContext>(undefined);

export const useClientPublicCandidateContext = () => {
    const context = React.useContext(ClientPublicCandidateContext);
    if (!context) {
        throw new Error(
            "useCandidateContext must be used within an appropriate provider"
        );
    }
    return context;
};

export const ClientPublicCandidateProvider = (props: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = useRelodeReducer(
        combinedReducers,
        initialClientPublicCandidateState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useCombinedClientPublicCandidateActions(state, dispatch);
    useCombinedClientPublicCandidateHandlers(state, actions);

    const value = {
        state,
        actions,
    } as IClientPublicCandidateContext;
    return <ClientPublicCandidateContext.Provider value={value} {...props} />;
};
